export const environment = {
  production: true,
  isDebugMode: false,
  serviceURL: location.origin,
  reportServiceURL: "data.local.reportServiceURL",
  gsfCalculationURL: `${location.origin}/`,
  sustainablityLoginUrl:
    "https://sustainability.platform.walmart.com/gigaton/login"
};
